import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonContent, IonGrid, modalController } from "@ionic/vue";
import { computed, ref } from "vue";
import { t } from "@/plugins/vue-i18n";

import { useListStore } from "@/stores/lists";
import { useUserStore } from "@/stores/user";

import { interactionFeedbackToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";

import { useProductModal } from "@/composables/viewFunctions/useProductModal";
import { useRouteParams } from "@/composables/useRouteParams";

import { PERMISSION_KEY } from "@/types/user";
import { AddProductModalPros } from "@/types/props";
import AddProductInterface from "@/components/modal/AddProductInterface.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddProductModal',
  props: {
    listId: {},
    product: {},
    supplierId: {},
    offset: {}
  },
  setup(__props: any) {

const props = __props

const listStore = useListStore()
const userStore = useUserStore()
const { addList } = useProductModal(props.listId, { offset: props.offset })

const { locationId } = useRouteParams()

const amount = ref<number>(0)

const isMax = computed<boolean>(() => props.product.amountMax ? amount.value <= props.product.amountMax : true)
const isMultiple = computed<boolean>(() => (amount.value % (props.product.amountStep ?? 1)) === 0)

const addToCart = (): void => {
    modalController.dismiss()

    listStore.addItemToCart(locationId.value, props.product.id, amount.value, undefined, props.offset).then((response) => {
        if (response) {
            listStore.getShoppingCart(locationId.value)
            interactionFeedbackToast(
                response,
                {
                    type: 'addCart',
                    id: 'add-product-cart'
                },
                {
                    cssClass: `toast-offset-${props.offset ?? 50}`
                },
                true
            )
        }
    })
}

const checkOverrideCartProduct = async (): Promise<void> => {
    if (listStore.catalogItemInCart(props.product.id)) {
        popAlertConfirm({
            message: t('messages.list.overrideCartList'),
            cancelText: t('button.cancel'),
            handler: {
                ok: addToCart
            }
        })
        return
    }

    addToCart()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), { class: "light-light-background" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), { class: "mt-2" }, {
        default: _withCtx(() => [
          _createVNode(AddProductInterface, {
            "show-cart": _unref(userStore).permission[_unref(PERMISSION_KEY).CART_ADD],
            "show-list": _unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_CREATE],
            isMultiple: isMultiple.value,
            isMax: isMax.value,
            amount: amount.value,
            "onUpdate:amount": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
            amountStep: __props.product.amountStep,
            amountMax: __props.product.amountMax,
            options: __props.product.packaging,
            name: __props.product.name,
            onCart: checkOverrideCartProduct,
            onList: _cache[1] || (_cache[1] = ($event: any) => (_unref(addList)(__props.product, amount.value, __props.supplierId)))
          }, null, 8, ["show-cart", "show-list", "isMultiple", "isMax", "amount", "amountStep", "amountMax", "options", "name"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})